<template>
	<div class="homePage_inlinet">
		<Panel hasShadow style="height: 488px" class="rank-pannel">
			<div class="flex-row flex-just-between">
				<span class="font-h2-medium flex-row-align-center">
					达人转化
					<Explain :content="tipContent" class="ml-4" icon="icon-a-help-circlebangzhu-mian" size="20"></Explain>
				</span>
			</div>
			<div class="main-content" v-loading="loading">
				<div class="pos-rela pt-20 flex-row data-content">
					<div class="left">
						<span class="Barlow-Bold fz-18 yx-color-text-primary white-bg pos-abso total-conversion-num">{{ totalRate | formatEmpty }}%</span>
					</div>
					<div class="content flex-row-align-center flex-1">
						<div class="flex-row flex-1">
							<div style="width: 160px">
								<div
									class="flex-row flex-align-start flex-just-end mt-20"
									:class="{ 'mt-4': !!index }"
									:style="'opacity: ' + (0.3 * 10 + index * 0.1 * 10) / 10"
									v-for="(item, index) in dataList"
									:key="item.key"
								>
									<div class="trapezoid primary-bg"></div>
									<div :style="'width: ' + (120 - index * 20) + 'px; height: 41px'" class="primary-bg"></div>
								</div>
							</div>
							<div class="flex-1">
								<div
									class="mt-20 flex-row primary-bg flex-row-align-center flex-just-end pr-12 item"
									:class="[!!index ? ' mt-4' : '', `opacity-${3 + index}`]"
									style="height: 41px"
									v-for="(item, index) in dataList"
									:key="item.key"
								>
									<span class="Barlow-Bold yx-color-white">{{ item.value | formatEmpty | formatPrice2 }}</span>
									<span class="font-h6-regular yx-color-white ml-8">{{ item.label }}</span>
								</div>
							</div>
						</div>
						<div style="width: 130px">
							<div
								class="pl-4 flex-row-align-center mt-20"
								style="height: 41px"
								v-for="(item, index) in rateList"
								:key="item.key"
								:class="{ 'mt-12': !!index }"
							>
								<el-image :src="require('@/assets/public/home-back-icon-1.png')" class="mt-4" style="width: 16px; height: 48px" lazy></el-image>
								<div>
									<span class="yx-color-text-secondary font-h6-regular ml-4">{{ item.label }}</span>
									<span class="Barlow-Bold yx-color-text-primary ml-4">{{ item.value | formatEmpty }}%</span>
								</div>
							</div>
						</div>
						<div class="arrow"><i class="el-icon-caret-right"></i></div>
					</div>
				</div>
			</div>
		</Panel>
	</div>
</template>
<script>
import Explain from '@/components/common/explain';
import { talentTransformation } from '@/api/home';

export default {
	props: {
		platformId: {
			type: [Number, String],
			default: null,
		},
		userIds: {
			type: Array,
			default: () => {
				return [];
			},
		},
		deptIds: {
			type: Array,
			default: () => {
				return [];
			},
		},
		params: {
			type: Object,
			default: () => {
				return {};
			},
		},
	},
	components: {
		Explain,
	},
	data() {
		return {
			dataList: [
				{ key: 'claimAnchorNum', label: '认领达人', value: undefined },
				{ key: 'buildAnchorNum', label: '建联达人', value: undefined },
				{ key: 'applyAnchorNum', label: '申样达人', value: undefined },
				{ key: 'sendAnchorNum', label: '寄样达人', value: undefined },
				{ key: 'liveAnchorNum', label: '交付达人', value: undefined },
				{ key: 'orderAnchorNum', label: '出单达人', value: undefined },
			],
			rateList: [
				{ key: 'buildRate', label: '建联率', value: undefined },
				{ key: 'applyRate', label: '申样率', value: undefined },
				{ key: 'sendRate', label: '寄样率', value: undefined },
				{ key: 'liveRate', label: '交付率', value: undefined },
				{ key: 'orderRate', label: '出单率', value: undefined },
			],
			totalRate: undefined,
			loading: false,
		};
	},
	created() {
		this.tipContent =
			'1.字段说明：\n认领达人：所选时间内认领的达人数。\n建联达人：所选时间内认领的达人中完成建联的达人数。\n申样达人：所选时间内认领的达人中进行申样的达人数。\n寄样达人：所选时间内认领的达人中已寄出样品的达人数。\n交付达人：所选时间内认领的达人中已交付的达人数。\n出单达人：所选时间内认领的达人中有订单产生的达人数。\n2.统计范围不包括自然出单达人和无样开播达人。';
	},
	computed: {
		searchParameters() {
			return {
				platformId: this.platformId,
				deptIds: this.deptIds,
				userIds: this.userIds,
				startTime: this.params.from_time,
				endTime: this.params.to_time,
			};
		},
	},
	watch: {
		searchParameters: {
			handler(val) {
				if (val.startTime && val.endTime) {
					this.getData();
				}
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		async getData() {
			this.loading = true;
			try {
				const { data } = await talentTransformation({ ...this.searchParameters });
				this.dataList = this.dataList.map(item => ({ ...item, value: data[item.key] }));
				this.rateList = this.rateList.map(item => ({ ...item, value: data[item.key] }));
				this.totalRate = data?.orderAnchorRate;
			} catch (error) {
				this.dataList = this.dataList.map(item => ({ ...item, value: undefined }));
				this.rateList = this.rateList.map(item => ({ ...item, value: undefined }));
				this.totalRate = undefined;
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>
<style lang="less" scoped>
.rank-pannel {
	display: flex;
	/deep/ .panel-body {
		display: flex;
		width: 100%;
		box-sizing: border-box;
		flex-direction: column;
		.data-content {
			flex: 1;
			// display: flex
		}
	}
}
.main-content {
	flex: 1;
}
.pos-rela {
	padding-top: 20px;
	margin-top: -20px;
	position: relative;
	top: 50%;
	transform: translateY(-50%);
}
.left {
	position: absolute;
	top: -22px;
	left: 30px;
	width: 30px;
	height: 320px;
	border-top: 2px solid @color-gy4;
	border-left: 2px solid @color-gy4;
	border-bottom: 2px solid @color-gy4;
	border-radius: 20px 0 0 20px;
	.total-conversion-num {
		top: 148px;
		transform: translateX(-50%);
	}
}
.content {
	margin-left: 63px;
	width: 100%;
	height: 218px;
	background-color: #fff;
	.arrow {
		position: absolute;
		width: 96px;
		height: 0;
		left: 60px;
		top: 300px;
		border-top: 1px solid @color-gy4;
		border-bottom: 1px solid @color-gy4;
		bottom: 8px;
		i {
			font-size: 24px;
			position: absolute;
			bottom: -12px;
			left: 86px;
			color: @color-gy4;
		}
	}
}
.primary-bg {
	background-color: @color-primary;
}
.trapezoid {
	margin-right: -12px;
	width: 40px;
	height: 41px;
	transform: skewX(30deg);
	border-radius: 4px 0 0 4px;
}
.opacity-8 {
	background-color: fadeout(@color-primary, 20);
}
.opacity-7 {
	background-color: fadeout(@color-primary, 30);
}
.opacity-6 {
	background-color: fadeout(@color-primary, 40);
}
.opacity-5 {
	background-color: fadeout(@color-primary, 50);
}
.opacity-4 {
	background-color: fadeout(@color-primary, 60);
}
.opacity-3 {
	background-color: fadeout(@color-primary, 70);
}
.item {
	border-radius: 0 4px 4px 0;
}
</style>
